import requests from "./httpService";

const SubusersServices = {
  getAllSubusers: async () => {
    return requests.get(`/user/viewallusers`);
  },


};

export default SubusersServices;
